import React from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import * as Routes from '../../../../constants/routes';
import { trackingEvent } from '../../../../helpers/tracking';

const tracking = {
    eventAction: 'Budget Calculator - Let’s Budget',
    eventLabel: 'Let’s Budget'
};

const createBoxItems = () =>{
    const checkMark = <svg className={styles.completeNoticeSvg} xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path fill="#C0CB23" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>;
    const completeText = [
        "Your Monthly Income",
        "Your Spouse's Monthly Income (if applicable)",
        "Your Monthly Savings",
        "Your Monthly Expenses"
    ];
    return completeText.map((text)=><p className={styles.completeNoticeItems}>{checkMark}<span className={styles.completeNoticeText}>{text}</span></p>);
};

export default () => (
    <div className={styles.page}>
        <div className={styles.contentContainer}>
            <h1 className={styles.mainTitle}>Budget Planner</h1>
            <p className={styles.text}>Creating a monthly budget just got easier. All you have to do is insert your net income, expenses and savings and you’ll get a clear picture of where you are financially.</p>
            <div className={styles.completeNotice}>
                <h2 className={styles.completeNoticeTitle}>To complete your calculations, you&nbsp;will&nbsp;need:</h2>
                {createBoxItems()}
            </div>
            <Link
                key='button'
                to={`${process.env.PUBLIC_URL}/budget-planner${Routes.STEPONE}`}
                rel='nofollow'
                onClick={() => trackingEvent(tracking)}
                className={styles.button}
                title='Start planning your budget'
            >
                Let's Budget!
            </Link>
        </div>
    </div>
);
